import React, { useState } from 'react';
import { Linkedin, Mail, MessageCircle, Link2, Check, Share2 } from 'lucide-react';
import { Button } from './ui/button';

/**
 * ShareButtons - Boutons de partage social professionnels
 * Respecte le RGPD (pas de tracking tiers, partage direct)
 */
const ShareButtons = ({ 
  url = window.location.href, 
  title = "SmartFacture AI - Facturation électronique 2026",
  description = "Préparez votre entreprise à la réforme e-facturation 2026. Factures Factur-X conformes, scanner IA, simulation PPF.",
  variant = "horizontal" // horizontal | vertical | compact
}) => {
  const [copied, setCopied] = useState(false);

  const encodedUrl = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);
  const encodedDescription = encodeURIComponent(description);

  const shareLinks = [
    {
      name: 'LinkedIn',
      icon: Linkedin,
      color: 'bg-[#0A66C2] hover:bg-[#004182]',
      url: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    },
    {
      name: 'WhatsApp',
      icon: MessageCircle,
      color: 'bg-[#25D366] hover:bg-[#128C7E]',
      url: `https://wa.me/?text=${encodedTitle}%20-%20${encodedUrl}`,
    },
    {
      name: 'Email',
      icon: Mail,
      color: 'bg-slate-600 hover:bg-slate-700',
      url: `mailto:?subject=${encodedTitle}&body=${encodedDescription}%0A%0A${encodedUrl}`,
    },
  ];

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy:', err);
    }
  };

  const handleShare = (shareUrl) => {
    window.open(shareUrl, '_blank', 'width=600,height=400,noopener,noreferrer');
  };

  if (variant === 'compact') {
    return (
      <div className="flex items-center gap-2">
        <span className="text-sm text-slate-500 mr-1">Partager :</span>
        {shareLinks.map((link) => {
          const Icon = link.icon;
          return (
            <button
              key={link.name}
              onClick={() => handleShare(link.url)}
              className={`p-2 rounded-full ${link.color} text-white transition-all hover:scale-110`}
              title={`Partager sur ${link.name}`}
              aria-label={`Partager sur ${link.name}`}
            >
              <Icon className="h-4 w-4" />
            </button>
          );
        })}
        <button
          onClick={handleCopyLink}
          className="p-2 rounded-full bg-slate-200 hover:bg-slate-300 text-slate-600 transition-all hover:scale-110"
          title="Copier le lien"
          aria-label="Copier le lien"
        >
          {copied ? <Check className="h-4 w-4 text-emerald-600" /> : <Link2 className="h-4 w-4" />}
        </button>
      </div>
    );
  }

  return (
    <div className={`flex ${variant === 'vertical' ? 'flex-col' : 'flex-row flex-wrap'} gap-3`}>
      {shareLinks.map((link) => {
        const Icon = link.icon;
        return (
          <Button
            key={link.name}
            onClick={() => handleShare(link.url)}
            className={`${link.color} text-white gap-2 rounded-xl`}
            size="sm"
          >
            <Icon className="h-4 w-4" />
            {link.name}
          </Button>
        );
      })}
      <Button
        onClick={handleCopyLink}
        variant="outline"
        size="sm"
        className="gap-2 rounded-xl border-slate-200"
      >
        {copied ? (
          <>
            <Check className="h-4 w-4 text-emerald-600" />
            Copié !
          </>
        ) : (
          <>
            <Link2 className="h-4 w-4" />
            Copier le lien
          </>
        )}
      </Button>
    </div>
  );
};

export default ShareButtons;
